<template>
    <div>
        <BaseTextInput v-model="firstName"
            :v="v.firstName"
            :label="firstNameLabel"
            :tip="firstNameTip"/>

        <BaseTextInput v-model="preferredName"
            :v="v.preferredName"
            :label="preferredNameLabel"
            :tip="preferredNameTip"/>

        <BaseTextInput v-model="lastName"
            :v="v.lastName"
            :label="lastNameLabel"
            :tip="lastNameTip"/>
    </div>
</template>

<script>
import UniqueId from 'vue-unique-id';
import BaseTextInput from '@/components/BaseTextInput.vue';

export default {
    components: {
        BaseTextInput,
    },
    props: {
        value: [Object],
        v: [Object],
        firstNameLabel: [String],
        firstNameTip: [String],
        preferredNameLabel: [String],
        preferredNameTip: [String],
        lastNameLabel: [String],
        lastNameTip: [String]
    },
    created() {
    },
    computed: {
        firstName: {
            get() {
                return this.value.firstName;
            },
            set(value) {
                this.v.firstName.$touch();
                this.$emit("input", { ...this.value, firstName: value });
            }
        },
        preferredName: {
            get() {
                return this.value.preferredName;
            },
            set(value) {
                this.v.preferredName.$touch();
                this.$emit("input", { ...this.value, preferredName: value });
            }
        },
        lastName: {
            get() {
                return this.value.lastName;
            },
            set(value) {
                this.v.lastName.$touch();
                this.$emit("input", { ...this.value, lastName: value });
            }
        },
    }
}
</script>